import { Component, Prop, Host, h } from '@stencil/core';

@Component({
  tag: 'spw-accordion-title',
  styleUrl: 'spw-accordion-title.scss',
  shadow: true,
})
export class SpwAccordionTitle {
  /** Tag html du titre de l'accordéon (de h1 à h6) */
  @Prop() tag?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h3';
  /** Si spécifié, place une icône à gauche du titre */
  @Prop() icon?: string;

  render() {
    const TagType = this.tag;
    const iconElement = this.icon ? <spw-icon icon={this.icon}></spw-icon> : null;
    return (
      <Host>
        <div class="spw-accordion-title">
          <div class="spw-accordion-title__content">
            <TagType class="spw-tw-flex">
              {iconElement && <div class="spw-tw-mr-3">{iconElement}</div>}
              <div>
                <slot></slot>
              </div>
            </TagType>
            <span class="spw-accordion-title__trigger">
              <spw-icon icon="fa-chevron-down"></spw-icon>
            </span>
          </div>
        </div>
      </Host>
    );
  }
}
